export const starknetAddress = '0x0126a13039b9122a2459f9b1053a8e0c25ad55a9096e7924b6d854cfc31ce8d7';
// export const starknetAddress = '0x06c6baefe2e3948d4c823e1d1be041c7775b1fda8b6414b4caaf31fb9c3832ec';
// export const starknetAddress = '0x071cdfdb934f450e8441dd201c5d89d5f6a82a68c02969de99f5481bd7a828f8';
export const ethAddress = "0x15b01475bb3070912216dc393c3a782cc90fa1f7";
